import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import Hero from './components/Hero';
import ValueProps from './components/ValueProps';
import KPIBanner from './components/KPIBanner';
import ProductTour from './components/ProductTour';
import Testimonials from './components/Testimonials';
import ValueBasedModel from './components/ValueBasedModel';
import FreeTrialBanner from './components/FreeTrialBanner';
import Footer from './components/Footer';
import VerifyEmail from './components/VerifyEmail';
import PricingTable from './components/PricingTable';
import BookACall from './components/BookACall';
import TopBar from './components/TopBar';
import ConsentBanner from './components/ConsentBanner';
import { PageViewTracker } from './analytics';
import IntercomLoader from './components/IntercomLoader';

const LandingPage = () => (
  <div className="App overflow-hidden">
    <style jsx global>{`
      .custom-tabs .ant-tabs-tab {
        border-radius: 16px !important;
        margin: 0 8px !important;
        transition: all 0.3s ease !important;
      }
      
      .custom-tabs .ant-tabs-tab-active {
        background: linear-gradient(135deg, #2E7D32, #4CAF50) !important;
        color: white !important;
      }
      
      .custom-tabs .ant-tabs-tab:hover {
        transform: translateY(-2px) !important;
      }
      
      .custom-table .ant-table-thead > tr > th {
        background: linear-gradient(135deg, rgba(46, 125, 50, 0.1), rgba(76, 175, 80, 0.1)) !important;
        border: none !important;
        font-weight: 700 !important;
      }
      
      .custom-table .ant-table-tbody > tr:hover > td {
        background: rgba(46, 125, 50, 0.05) !important;
      }
      
      .custom-collapse .ant-collapse-item {
        border-radius: 20px !important;
        margin-bottom: 16px !important;
        border: none !important;
        box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1) !important;
      }
      
      .custom-collapse .ant-collapse-header {
        border-radius: 20px !important;
        background: linear-gradient(135deg, rgba(255, 255, 255, 0.9), rgba(244, 247, 250, 0.9)) !important;
      }
      
      .custom-dots .slick-dots li button {
        background: rgba(46, 125, 50, 0.3) !important;
        border-radius: 50% !important;
      }
      
      .custom-dots .slick-dots li.slick-active button {
        background: #2E7D32 !important;
      }
      
      .ant-carousel .slick-dots {
        bottom: -50px !important;
      }
      
      .ant-carousel .slick-dots li {
        margin: 0 8px !important;
      }
      
      .ant-carousel .slick-dots li button {
        width: 12px !important;
        height: 12px !important;
        border-radius: 50% !important;
      }
    `}</style>
    <TopBar />
    <Hero />
    <PageViewTracker />
    <IntercomLoader />
    <ValueProps />
    <KPIBanner />
    <ProductTour />
    <Testimonials />
    <PricingTable />
    <FreeTrialBanner />
    <BookACall />
    <Footer />
    <ConsentBanner />
  </div>
);

const App = () => {
  return (
    <Router>
      <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#2E7D32',
          colorBgContainer: '#F4F7FA',
          colorText: '#1B2124',
          borderRadius: 16,
          fontSize: 16,
        },
        components: {
          Tabs: {
            cardBg: 'rgba(255, 255, 255, 0.8)',
            itemSelectedColor: '#2E7D32',
            itemHoverColor: '#2E7D32',
            inkBarColor: '#2E7D32',
          },
          Table: {
            headerBg: 'rgba(46, 125, 50, 0.05)',
            headerColor: '#1B2124',
            rowHoverBg: 'rgba(46, 125, 50, 0.05)',
          },
          Collapse: {
            headerBg: 'rgba(255, 255, 255, 0.8)',
            contentBg: 'rgba(255, 255, 255, 0.9)',
          },
          Card: {
            boxShadowTertiary: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
          }
        },
      }}
    >
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
        </Routes>
      </ConfigProvider>
    </Router>
  );
};

export default App;
